/*
 *
 * Users constants
 *
 */

export const SLICE_NAME = 'users';
